import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getSubjectList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getSubjectList',
        parameter: {
            date: action.date,
            admin: action.admin,
            subjectKbn: action.subjectKbn,
            limitedSubjectSet: action.limitedSubjectSet
        },
    }
    const data = yield call(http.post, info);

    yield put({
        type: "LoadEnd",
    });
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getSubjectList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getSubjectListSaga = takeEvery('GetSubjectList_Saga', getSubjectList);

function* setSubject(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setSubject',
        parameter: {
            id: action.subject.id,
            type: action.subject.type,
            limitedSubjectSet: action.subject.limitedSubjectSet,
            difficulty: action.subject.difficulty,
            title: action.subject.title,
            author: action.subject.author,
            releaseDate: action.subject.releaseDate,
            releaseTime: action.subject.releaseTime,
            releaseFlg: action.subject.releaseFlg,
            audio: action.subject.audio,
            textEn: action.subject.textEn,
            textJp: action.subject.textJp,
            check: action.subject.check,
            order: action.subject.order,
            source: action.subject.source,
            english: action.subject.english,
            subjectKbn: action.subject.subjectKbn,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.id);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setSubject",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const setSubjectSaga = takeEvery('SetSubject_Saga', setSubject);

function* deleteSubject(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/deleteSubject',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(action.id);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "deleteSubject",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const deleteSubjectSaga = takeEvery('DeleteSubject_Saga', deleteSubject);

function* changeReleaseSubject(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/changeReleaseSubject',
        parameter: {
            id: action.id,
            releaseFlg: action.releaseFlg
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(action.id, action.releaseFlg);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "changeReleaseSubject",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const changeReleaseSubjectSaga = takeEvery('ChangeReleaseSubject_Saga', changeReleaseSubject);

function* changeOrder(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/changeOrder',
        parameter: {
            id: action.id,
            order: action.order,
            mode: action.mode
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(action.index);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "changeOrder",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const changeOrderSaga = takeEvery('ChangeOrder_Saga', changeOrder);
